/* jshint eqnull:true */
define(["jquery"], function($) {
	
	function invokeService(url, data, dataType, timeout) {
		if(dataType == null || dataType === '') {
			dataType = "json";
		}

		var timeOutAmount = timeout || null;

		return $.ajax({
			url: url,
			type: "POST",
			data: data,
			dataType: dataType,
			traditional: true,
			timeout: timeOutAmount
		}).then(
			function (response) {
				if(response && response.errorMessage) {
					return $.Deferred().reject(response);
				}
				return response;
			}, 
			function(jqXHR, textStatus){
				return jqXHR;
			}
		);
	}
	
	function serializeObject(form) {
		var params = $(form).serializeArray(), paramObj = {};
		$.each(params, function(k,v) {
			if (paramObj[v.name]) {
				if (!$.isArray()) {
					paramObj[v.name] = [paramObj[v.name]];
				}
				paramObj[v.name].push(v.value);
			} else {
				paramObj[v.name] = v.value;
			}
		});
		return paramObj;
	}
	
	function submitForm(form, params, responseType, timeout) {
		var $form = $(form).first(), 
			action = $form.attr('action'), 
			data = $.extend(serializeObject($form), params);
		return invokeService(action, data, responseType, timeout);
	}
	
	return {
		invokeService: invokeService,
		serializeObject: serializeObject,
		submitForm: submitForm
	};
});